import { render, staticRenderFns } from "./TabsSelection.vue?vue&type=template&id=32175a86&scoped=true"
import script from "./TabsSelection.vue?vue&type=script&lang=js"
export * from "./TabsSelection.vue?vue&type=script&lang=js"
import style0 from "./TabsSelection.vue?vue&type=style&index=0&id=32175a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32175a86",
  null
  
)

export default component.exports